import { html } from "uhtml";
import { locales } from "../../models/locales.js";
import {
	autoHideToolbar,
	disableAnimation,
	showNavigation,
} from "../../view-models/app-signals.js";

export function openCloseToggle(locale = "en") {
	const show = showNavigation();
	const className = show ? "icon menu open inactive-icon" : "icon menu open";
	const disable = disableAnimation();
	const animationDelay = autoHideToolbar();
	const style = !disable
		? `border-radius:100%; background-color: transparent; animation: 500ms ease-in-out ${animationDelay}ms autohideblink 3; outline: none;`
		: "";
	return html`<div class="controls-trigger" style="${style}">
		<button class="trigger" aria-expanded="false" @click=${() => showNavigation(!show)}>
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19 19" preserveAspectRatio="xMidYMid meet" role="img" class="${className}" aria-labelledby="menu-icon">
  <title id="menu-icon">${locales.menuIcon[locale]}</title>
  <circle cx="9.626" cy="3.237" r="1.376"></circle><circle cx="9.625" cy="9.6" r="1.375"></circle><circle cx="9.625" cy="15.962" r="1.375"></circle>
</svg>
  </button>
</div>`;
}
